import React from 'react';
import { lazySetContainerInSection } from '../';
import type { AppSectionName } from '../interface/AppSection';

export function useRegisterNavigationLoopContainer(
    sectionName: AppSectionName,
    containerRef: React.RefObject<HTMLElement>,
    shouldSkipAdding: boolean = false,
    depsArray: React.DependencyList = []
): void {
    const promiseRef = React.useRef<Promise<() => void> | undefined>();
    React.useEffect(() => {
        if (shouldSkipAdding) {
            return;
        }

        promiseRef.current = lazySetContainerInSection.importAndExecute(
            sectionName,
            containerRef.current
        );

        return () => {
            promiseRef.current?.then(disposeCb => {
                disposeCb?.();
                promiseRef.current = undefined;
            });
        };
    }, depsArray);
}
